/** How long an error toast stays on screen, in seconds (project rule). */
export const ERROR_TOAST_SECONDS = 3.5;
